import './Translator.css';
import TextareaAutosize from 'react-textarea-autosize';

// -------------------------------------------------------------------------- //

const MAX_INPUT_SIZE = process.env.REACT_APP_MAX_INPUT_SIZE;

// -------------------------------------------------------------------------- //

// This timer will trigger a translation request to the API
let timer = null;

// This will hold the spoken version for the text that is currently entered
let audio = null;

// Holds the JWT representation of the current text
let audioJwt = null;

// -------------------------------------------------------------------------- //

const truncate = (input, maxLength) => {
  return input.length > maxLength
    ? input.substring(0, maxLength)
    : input;
};

// -------------------------------------------------------------------------- //

const updateCounter = (value) => {
  document.getElementById('character-count').innerText = value
};

// -------------------------------------------------------------------------- //

const processInput = (event) => {
  const input = truncate(event.target.value, MAX_INPUT_SIZE);
  updateCounter(input.length);

  if (timer) {
    clearTimeout(timer);
  }

  timer = scheduleTranslation(input);
};

// -------------------------------------------------------------------------- //

const scheduleTranslation = (input) => {
  return setTimeout(() => {
    const replyBalloon = document.getElementById('reply');
    const speaker = document.getElementById('speaker');
    const error = 'The service is now even stuck. Come over an hour but back.';

    const request = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({text: input})
    };

    fetch(process.env.REACT_APP_TRANSLATION_SERVICE + '/translate', request)
      .then((response) => response.json())
      .then((data) => {
        replyBalloon.innerHTML = data.text.replace('\n', '<br />')

        if (data.text && data.pron) {
          speaker.className = 'speaker';
          speaker.dataset.pron = data.pron;
        } else {
          speaker.className = 'speaker --hidden';
        }
      })
      .catch(() => {
        replyBalloon.textContent = error;
        speaker.className = 'speaker --hidden';
      })
  }, 1800);
};

// -------------------------------------------------------------------------- //

const speak = (event) => {
  // Fetch new audio if necessary
  if (event.target.dataset.pron !== audioJwt) {
    const service = process.env.REACT_APP_TRANSLATION_SERVICE
    const path = service + '/speak?pron=' + event.target.dataset.pron
  
    audio = new Audio(path);
    // Make sure spoken version can be played again
    audio.addEventListener('ended', () => {
      audio.currentTime = 0;
    });

    // Lazy man’s cache key
    audioJwt = event.target.dataset.pron;
  }

  // If currently playing, stop doing that and make it start from 0 next time
  if (!audio.paused || audio.currentTime) {
    audio.pause();
    audio.currentTime = 0;
    return;
  }

  // Otherwise just play
  audio.play();
}

// -------------------------------------------------------------------------- //

const Translator = () => {
  return (
    <div className="Translator">
      {/*
        * This is where the user can input their Dutch text
        */}
      <div className="character --dutch">
        <div className="balloon --query">
          <TextareaAutosize className="textarea"
                            minRows="2"
                            maxLength={MAX_INPUT_SIZE}
                            autoFocus="autofocus"
                            onChange={processInput} />
          <div className="counter --no-select">
            <span id="character-count">0</span> / {MAX_INPUT_SIZE}
          </div>
        </div>
      </div>

      {/*
        * This shows the translated text
        */}
      <div className="character --english">
        <div className="balloon --reply">
          <span id="reply"></span>
          <button id="speaker" className="speaker --hidden" onClick={speak}>
            Speak
          </button>
        </div>
      </div>
    </div>
  );
};

// -------------------------------------------------------------------------- //

export default Translator;
